import React, { Component } from 'react';
import { ChevronDown, CloseIcon, Profile } from '@dbk/ui-icons';
import { PALETTE, ROUTES , ArrowRight} from '../../../constants';

class Bar extends Component {

// componentDidMount()


  render = () => {
    let _NOTIFY = "";
    let _MESSAGE ="";
    let _ICON_COLOR=PALETTE.secondaryText;

    if (this.props.notify == true){
      _NOTIFY = 'notify';
      _ICON_COLOR=PALETTE.secondaryActive;
    }

    if (this.props.message && this.props.message == true ){
      _MESSAGE= ` (${this.props.newMsgLabel})`;
    }

    let chevronClass = "show-icon icon";
    if (this.props.show) {
      chevronClass = "icon";
    }

      return (
        <div className={'bar ' + _NOTIFY  + ' margin-bottom-2' } onClick={this.props.onExpand} >


          <div className="row">
            <div className="columns small-12">
              <div className="header-text">
                <div className="title">
                  <span>Chat </span>
                  <span>{_MESSAGE}</span>

                </div>

                <div className="icon-float-right">


                  <ChevronDown width={15} color={_ICON_COLOR} className={chevronClass} />
                  <span onClick={this.props.onClose }>
                    <CloseIcon width={10} color={_ICON_COLOR} className="icon" />
                  </span>

                </div>
              </div>
            </div>






          </div>


        </div>

      );
  }


}
export default Bar;